import { useEffect } from "react"
import { useAuthStore } from "stores"
import { useGet } from "utils/useFetch"

const useExtendUser = () => {
  const extendUser = useAuthStore((state) => state.extendUser)
  const user = useAuthStore((state) => state.user)

  const { isLoading: isLoadingTracker } = useGet<ITracker>({
    url: `/api/v2/admin/performance/tracker`,
    queryKey: ["extended-user-performance-tracker", user?.personKey as string],
    instanceKey: "newArchAxiosInstance",
    // staleTime: Infinity,
    onSuccess: (data: ITracker) => {
      const {
        isOrgSetup,
        isReviewTypeSetup,
        isObjectiveStatusRangeSetup,
        isRatingsLabelSetup,
        isScoreRatingSetup,
        isWeightDistrubutionSetup,
        isCoreValueSetup,
      } = data?.data

      extendUser({
        isNewPerformanceSetupCompleted:
          isOrgSetup &&
          isReviewTypeSetup &&
          isObjectiveStatusRangeSetup &&
          isRatingsLabelSetup &&
          isScoreRatingSetup &&
          isWeightDistrubutionSetup &&
          isCoreValueSetup,
      })
    },
  })

  const { isLoading: isLoadingCheckHOD } = useGet<ICheckHOD>({
    url: `/api/v2/admin/performance/checkhod`,
    queryKey: ["performance-check-hod", user?.personKey as string],
    instanceKey: "newArchAxiosInstance",
    // staleTime: Infinity,
    onSuccess: (data: ICheckHOD) => {
      const { isHod, departmentId, departmentName } = data?.data || {}
      extendUser({
        isHOD: isHod,
        departmentId,
        departmentName,
      })
    },
  })

  useEffect(() => {
    extendUser({
      isLoadingInfo: isLoadingTracker || isLoadingCheckHOD,
      isLoadingPerformanceTracker: isLoadingTracker,
      isLoadingHODCheck: isLoadingCheckHOD,
    })
  }, [isLoadingTracker, isLoadingCheckHOD])

  return {}
}

export default useExtendUser

interface SetupProgress {
  isOrgSetup: boolean
  isReviewTypeSetup: boolean
  isWeightDistrubutionSetup: boolean
  isScoreRatingSetup: boolean
  isObjectiveStatusRangeSetup: boolean
  isRatingsLabelSetup: boolean
  isCoreValueSetup: boolean
}
type ITracker = IBaseRes<SetupProgress>

type ICheckHOD = IBaseRes<ILoggedInManagerInfo>
interface ILoggedInManagerInfo {
  isHod: boolean
  departmentId: number
  departmentName: string
}
